import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL

console.log('API URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add Firebase ID token to requests if available
api.interceptors.request.use(async (config) => {
  try {
    // Get Firebase ID token from the current user
    const { getAuth } = await import('firebase/auth');
    const { getApp } = await import('firebase/app');
    const app = getApp();
    const auth = getAuth(app);
    const user = auth.currentUser;
    
    console.log('API Interceptor - User present:', !!user);
    console.log('API Interceptor - Request URL:', config.baseURL + config.url);
    
    if (user) {
      try {
        const idToken = await user.getIdToken();
        console.log('API Interceptor - Token obtained:', !!idToken);
        config.headers.Authorization = `Bearer ${idToken}`;
      } catch (error) {
        console.error('Error getting ID token:', error);
      }
    } else {
      console.log('API Interceptor - No user found');
    }
  } catch (error) {
    console.error('API Interceptor error:', error);
  }
  
  return config;
});

// Add response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    console.log('API Response - Success:', response.config.url, response.status);
    return response;
  },
  (error) => {
    console.log('API Response - Error:', error.config?.url, error.response?.status, error.message);
    return Promise.reject(error);
  }
);

export const auth = {
  sendOtp: (phone) => api.post('/auth/otp/send', { phone }),
  verifyOtp: (phone, otp) => api.post('/auth/otp/verify', { phone, otp }),
};

export const regions = {
  initialize: () => api.post('/product/regions/initialize'),
  add: (data) => api.post('/product/regions', data),
  getAll: () => api.get('/product/regions'),
  getByCode: (code) => api.get(`/product/regions/code/${code}`),
  validateQR: (qrData) => api.post('/product/regions/validate-qr', { qrData }),
};

export const authCodes = {
  generate: (data) => api.post('/product/codes/generate', data),
  getAll: (params) => api.get('/product/codes', { params }),
  getAllForVerification: () => api.get('/product/codes/verify'),
  markAsUsed: (productCode, verificationData) => api.put(`/product/codes/${productCode}/mark-used`, verificationData),
  getVerificationLogs: (params) => api.get('/product/logs', { params }),
  verifyProduct: (code, data) => api.post(`/product/verify/${code}`, data),
  checkAuthenticity: ({ productCode, authenticityCode }) => api.post(`/product/authenticity/${productCode}`, { authenticityCode }),
  updatePrintingStatus: (productCode, sendToPrinting) => api.put('/product/codes/update-printing', { productCode, sendToPrinting }),
  updateManyPrintingStatus: (productCodes, sendToPrinting) => api.put('/product/codes/update-many-printing', { productCodes, sendToPrinting }),
  verifyProductCode: (data) => api.post('/product/verify-code', data),
};

export const scratchCards = {
  generate: (data) => api.post('/loyalty/generate', data),
  getAll: (params) => api.get('/loyalty/cards', { params }),
  getStats: (params) => api.get('/loyalty/stats', { params }),
  resetPoints: () => api.post('/loyalty/reset-points'),
  redeem: (code) => api.post('/loyalty/redeem', { code }),
  getUserPoints: () => api.get('/loyalty/points'),
  updatePrintingStatus: (cardId, sendToPrinting) => api.put('/loyalty/update-printing', { cardId, sendToPrinting }),
  updateManyPrintingStatus: (cardCodes, sendToPrinting) => api.put('/loyalty/update-many-printing', { cardCodes, sendToPrinting }),
  getUsers: () => api.get('/loyalty/users'),
  deductUserPoints: (userId, points) => api.post('/loyalty/deduct-points', { userId, points }),
  getUserHistory: (userId) => api.get(`/loyalty/user-history/${userId}`),
  getMyHistory: () => api.get('/loyalty/my-history'),
  getLeaderboard: () => api.get('/loyalty/leaderboard'),
};

export default api;